import { api } from "./axios";

export const tourApi = {
  getTourLog: (userId: number) => api.get(`/users/${userId}/tour-log`),
  createTourLog: (userId: number, data: { is_completed: boolean }) =>
    api.post(`/users/${userId}/tour-log`, data),
  updateTourLog: (userId: number, data: { is_completed: boolean }) =>
    api.put(`/users/${userId}/tour-log`, data),
};
